import React from 'react';
import IsConnected from '../../IsConnected/IsConnected'
import AllPassedEvent from './AllPassedEvent'

class ParselAllPassedEvent extends React.Component {

 render() {
   const {...props} = this.props
   return (
     <IsConnected Component={AllPassedEvent} {...props}/>
   )
 }
}



export default ParselAllPassedEvent;
